import React, { useState } from 'react';

function MesSelectionModal({ show, onClose, onConfirm, title, isLoading }) {
  const [selectedMes, setSelectedMes] = useState('');

  const meses = [
    { value: '1', label: 'Janeiro' },
    { value: '2', label: 'Fevereiro' },
    { value: '3', label: 'Março' },
    { value: '4', label: 'Abril' },
    { value: '5', label: 'Maio' },
    { value: '6', label: 'Junho' },
    { value: '7', label: 'Julho' },
    { value: '8', label: 'Agosto' },
    { value: '9', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
  ];

  const handleConfirm = () => {
    if (selectedMes && onConfirm) {
      onConfirm(parseInt(selectedMes));
    }
  };

  const handleClose = () => {
    setSelectedMes('');
    onClose();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-primary py-2">
            <h6 className="modal-title text-white m-0">
              <i className="bi bi-calendar-month me-2"></i>
              {title || 'Selecione o Mês'}
            </h6>
            <button
              type="button"
              className="btn-close btn-close-white shadow-sm p-2"
              onClick={handleClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center mb-3">
              <i
                className="bi bi-calendar-check text-primary me-3"
                style={{ fontSize: '2rem' }}
              ></i>
              <div>
                <p className="mb-1">
                  Selecione o mês para gerar o relatório de despesas:
                </p>
                <small className="text-muted">
                  O relatório incluirá todas as despesas do mês selecionado.
                </small>
              </div>
            </div>

            <div className="row">
              {meses.map(mes => (
                <div key={mes.value} className="col-md-4 col-6 mb-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="mes"
                      id={`mes-${mes.value}`}
                      value={mes.value}
                      checked={selectedMes === mes.value}
                      onChange={e => setSelectedMes(e.target.value)}
                      disabled={isLoading}
                    />
                    <label
                      className="form-check-label w-100"
                      htmlFor={`mes-${mes.value}`}
                      style={{ cursor: 'pointer' }}
                    >
                      {mes.label}
                    </label>
                  </div>
                </div>
              ))}
            </div>

            {isLoading && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <div
                    className="spinner-border spinner-border-sm text-primary me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                  <div>
                    <span className="text-muted">
                      Gerando relatório para{' '}
                      {meses.find(m => m.value === selectedMes)?.label}...
                    </span>
                    <br />
                    <small className="text-muted">
                      Por favor, aguarde. O PDF será aberto automaticamente.
                    </small>
                  </div>
                </div>
                <div className="progress mt-2" style={{ height: '3px' }}>
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: '100%' }}
                  ></div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              <i className="bi bi-x-lg me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={isLoading || !selectedMes}
            >
              {isLoading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                  Gerando...
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-pdf me-1"></i>
                  Gerar Relatório
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MesSelectionModal;
